module.exports = __webpack_public_path__ + "img/roundClose2x.png?7adfb0997ca43b2331b2f6668d82c3fd";